export const Type = {
  SET_CURRENT_POINT: "FAERUN_SET_CURRENT_POINT",
  UPDATE_CURRENT_POINT: "FAERUN_UPDATE_CURRENT_POINT",
};

export const setCurrentPoint = data => ({ type: Type.SET_CURRENT_POINT, data });

export const updatePointData = data => ({ type: Type.UPDATE_CURRENT_POINT, data });
